import { CheckCircle, Report } from '@mui/icons-material'
import { styled } from '@mui/material'

export const Grid = styled('div')({
   width: '100%',
   height: '100%',
   display: 'grid',
   gap: 25,
   gridTemplateColumns: 'repeat(8, 1fr)',
   gridTemplateRows: 'repeat(2, 350px)',
})

export const StyledCheck = styled(CheckCircle)({
   fontSize: 14,
   marginBottom: '-2px',
   color: 'rgb(0,95,39)',
})

export const ImportantIcon = styled(Report)({
   fontSize: 17,
   marginBottom: '-2px',
   color: 'red',
})
